export var track = function (name, payload) {
    if (typeof window !== 'undefined') {
        window.LIFE_CYCLE_EVENT_BUS.trigger(name, payload);
    }
};
export var trackOnce = function () {
    var executed = false;
    return function (name, payload) {
        if (!executed) {
            track(name, payload);
        }
        executed = true;
    };
};
export var getSortAnalyticsPayload = function (sortedBy, orderBy) {
    var sortLabels = {
        addedByName: 'created by',
        createTime: 'created on',
        jobName: 'po/job name',
    };
    var orderLabels = {
        asc: 'ascending',
        desc: 'descending',
    };
    return {
        sortedBy: sortLabels[sortedBy],
        sortDirection: orderLabels[orderBy],
    };
};
export var getTableViewAnalyticsOption = function (textContent, prevRows, curRows) {
    if (/view all|view less/.test(textContent)) {
        return textContent;
    }
    return /^(10|25|50)$/.test(curRows.toString())
        ? "view ".concat(curRows)
        : 'view all';
};
